import React, { FC } from 'react';
import { blenderCss } from '@cld/blender';
import { useFoundationContext } from '@cld/design-system-foundations';
import Progress from '@cld/progress';
import { Button } from './Button';
import { ButtonProps } from './types';

export interface ProgressButtonProps extends Omit<ButtonProps, 'leftSlot'> {
  showSpinner?: boolean;
}

const Spinner: FC = () => {
  const context = useFoundationContext();
  return (
    <Progress.Logo
      size={context?.size ?? /* istanbul ignore next */ 'sm'}
      strokeWidth="11"
      color1={blenderCss.foregroundFromCssVariables}
      color2={blenderCss.foregroundFromCssVariables}
    />
  );
};

export const ProgressButton: FC<ProgressButtonProps> = ({ showSpinner = false, ...rest }) => <Button leftSlot={showSpinner && <Spinner />} {...rest} />;
